import React, { memo } from 'react';
import { CTAButtonProps } from '../../types';
import styles from './CTAButton.module.css';

const CTAButton: React.FC<CTAButtonProps> = memo(({ 
    text, 
    onClick = () => console.log('CTA button clicked'), 
    className = '', 
    noAnimation = false 
}) => {
    const buttonClass = `${styles.ctaButton} ${noAnimation ? styles.noAnimation : ''} ${className}`;

    return (
        <button
            className={buttonClass}
            onClick={onClick}
            type="button"
        >
            <span className={styles.ctaButtonText}>{text}</span>
        </button>
    );
});

CTAButton.displayName = 'CTAButton';

export default CTAButton; 